import { createAction, props } from '@ngrx/store';

export enum LocationsActions {
  LocationsRequested = '[Locations] Locations Requested',
  LocationsLoaded = '[Locations] Locations Loaded',
  LocationsError = '[Locations] Locations Error',
  AddLocation = '[Locations] Add Location',
  AddLocationSuccess = '[Locations] Add Location Success',
  AddLocationError = '[Locations] Add Location Error',
  UpdateLocation = '[Locations] Update Location',
  UpdateLocationSuccess = '[Locations] Update Location Success',
  UpdateLocationError = '[Locations] Update Location Error',
  DeleteLocation = '[Locations] Delete Location',
  DeleteLocationSuccess = '[Locations] Delete Location Success',
  DeleteLocationError = '[Locations] Delete Location Error'
}

export const LocationsRequested = createAction(LocationsActions.LocationsRequested);

export const LocationsLoaded = createAction(LocationsActions.LocationsLoaded,
    props<{ locations: [] }>());

export const LocationsError = createAction(LocationsActions.LocationsError);

export const AddLocation = createAction(
  LocationsActions.AddLocation,
  props<{ location: any }>()
);

export const AddLocationSuccess = createAction(
  LocationsActions.AddLocationSuccess,
  props<{ location: any }>()
);

export const AddLocationError = createAction(LocationsActions.AddLocationError);

export const UpdateLocation = createAction(
  LocationsActions.UpdateLocation,
  props<{ location: any, skipToast?: boolean }>()
);

export const UpdateLocationSuccess = createAction(
  LocationsActions.UpdateLocationSuccess,
  props<{ location: any }>()
);

export const UpdateLocationError = createAction(LocationsActions.UpdateLocationError);

export const DeleteLocation = createAction(
  LocationsActions.DeleteLocation,
  props<{ id: any }>()
);

export const DeleteLocationSuccess = createAction(
  LocationsActions.DeleteLocationSuccess,
  props<{ id: any }>()
);

export const DeleteLocationError = createAction(LocationsActions.DeleteLocationError);